import { useRouter } from 'next/router'
import { NextPaths } from '../../../../router/next-paths'
import { fetchCurrentProvider } from '../../../../hooks/queries/providers'
import { needsOnboarding } from '../../../../utils/onboarding'
import { AuthRedirectOptions } from '../types'

export const getRedirectPath = (options: AuthRedirectOptions = {}) => {
  const { userType, returnUrl } = options

  if (returnUrl) {
    return returnUrl
  }

  if (userType === 'admin') {
    return NextPaths.adminHome
  }

  return NextPaths.providerHome
}

export const getFormWidth = (type: string): string => {
  switch (type) {
    case 'register':
      return '430px'
    case 'login':
      return '430px'
    default:
      return '400px'
  }
}

export const useAuthRedirect = () => {
  const router = useRouter()

  const getRedirectOptions = (): AuthRedirectOptions => {
    return {
      userType: undefined,
      returnUrl: router.query.returnUrl as string,
    }
  }

  const redirectAfterAuth = async (userType?: string) => {
    const options = getRedirectOptions()
    options.userType = userType

    if (!options.returnUrl && userType === 'provider') {
      try {
        const provider = await fetchCurrentProvider()
        if (needsOnboarding(provider)) {
          router.replace(NextPaths.providerRegister)
          return
        }
      } catch {
        // If provider fetch fails, fall through to default redirect
      }
    }

    const redirectPath = getRedirectPath(options)
    router.replace(redirectPath)
  }

  return {
    getRedirectOptions,
    redirectAfterAuth,
  }
}
